import React from 'react';
import { PageWrapper } from 'components/modules/wrapper';
import { CardSection, HeroSection, SubImgSection } from 'components/layout/Organization';

function OrganizationView() {
  return (
    <PageWrapper>
      <section>
        <HeroSection />
      </section>
      <section>
        <CardSection />
      </section>
      <section>
        <SubImgSection />
      </section>
    </PageWrapper>
  );
}

export default OrganizationView;
